import { makeObservable, observable, action } from 'mobx';
import DevelopRequests from 'Utils/Requests/DevelopRequests';

class DeveloperSettingsStore {
    settings;

    constructor() {
        makeObservable(this, {
            settings: observable
        });
        this.settings = {};
    }

    GetSettings = action(() => {
        DevelopRequests.GetDeveloperSettings().then(action((values) => {
            this.settings = values;
        }));
    });

    SaveSettings() {
        DevelopRequests.SaveDeveloperSettings(this.settings).then(values => {
            window.location.href = window.location.href;
        });
    };
}

export default new DeveloperSettingsStore();